import { render, staticRenderFns } from "./SendIcon.vue?vue&type=template&id=f3aa2194&scoped=true"
import script from "./SendIcon.vue?vue&type=script&lang=js"
export * from "./SendIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3aa2194",
  null
  
)

export default component.exports